/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateMyUserOnboardingProgressMutationRequest,
  UpdateMyUserOnboardingProgressMutationResponse,
} from "../types/UpdateMyUserOnboardingProgress.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateMyUserOnboardingProgressMutationKey = () =>
  [{ url: "/v1/user-onboarding/me/progress" }] as const

export type UpdateMyUserOnboardingProgressMutationKey = ReturnType<
  typeof updateMyUserOnboardingProgressMutationKey
>

/**
 * @description Supplier portal users only. Persists the authenticated user's current onboarding step.
 * @summary Update current user onboarding progress
 * {@link /v1/user-onboarding/me/progress}
 */
export async function updateMyUserOnboardingProgress(
  data: UpdateMyUserOnboardingProgressMutationRequest,
  config: Partial<
    RequestConfig<UpdateMyUserOnboardingProgressMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateMyUserOnboardingProgressMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateMyUserOnboardingProgressMutationRequest
  >({
    method: "PUT",
    url: `/v1/user-onboarding/me/progress`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateMyUserOnboardingProgressMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<UpdateMyUserOnboardingProgressMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = updateMyUserOnboardingProgressMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateMyUserOnboardingProgressMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyUserOnboardingProgressMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return updateMyUserOnboardingProgress(data, config)
    },
  })
}

/**
 * @description Supplier portal users only. Persists the authenticated user's current onboarding step.
 * @summary Update current user onboarding progress
 * {@link /v1/user-onboarding/me/progress}
 */
export function useUpdateMyUserOnboardingProgress<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateMyUserOnboardingProgressMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: UpdateMyUserOnboardingProgressMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateMyUserOnboardingProgressMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? updateMyUserOnboardingProgressMutationKey()

  const baseOptions = updateMyUserOnboardingProgressMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateMyUserOnboardingProgressMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyUserOnboardingProgressMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateMyUserOnboardingProgressMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyUserOnboardingProgressMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateMyUserOnboardingProgressMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: UpdateMyUserOnboardingProgressMutationRequest },
    TContext
  >
}
